<template>
    <div class="row required-documents">
        <div class="col-12 display-webkit-inline" v-for="(item, index) in data" :key="index">
            <span class="circle"
                ><span class="icon-arrow_forward_ios"></span
            ></span>
            <p v-html = "item.title">
            </p>
            <br />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PopupButton from '@/components/registration/PopupButton.vue'
export default {
    components: {
        PopupButton,
    },
    data() {
        return {
            data: [],
        }
    },
    methods: {
        setValues() {
            this.data.push(
                {
                    title: 'Original Scanned NICOP/POC/CNIC',
                },
                {
                    title: 'Original Scanned Passport (First Two Pages)',
                },
                {
                    title: 'Proof of NRP Status (Scanned Passport\'s Entry/Exit Stamps)',
                },
                {
                    title: 'Live Photo',
                },
                {
                    title: 'Scanned Signature (on white page)',
                },
                {
                    title: 'Proof of profession and Source of Income/Funds (' +`<a>Click here</a>` + ' for Details)',
                },
                {
                    title: 'Zakat Declaration Form (if applicable)',
                },
            )
        },
        agreeToTermsAndConditions() {
            this.$emit('agreed')
        },
    },
    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.setValues()
    },
}
</script>